import { Separator as SeparatorUi } from '@carboncopyco/ui';

export const Separator = () => (
  <SeparatorUi
    horizontal
    color="bg-ds-natural-150"
  />
);
